var Storage = {
    // 设置缓存
    localSet: function (name, data) {
        let nowDate=parseInt((new Date()).getTime() / 1000);
        localStorage.setItem(name,JSON.stringify({data:data,expiresOn:nowDate}));
    },
    // 获取缓存
    localGet: function (name) {
        let nowDate=parseInt((new Date()).getTime() / 1000);
        var data = localStorage.getItem(name);
        var dataObj = JSON.parse(data);
        if (dataObj == null || (nowDate - dataObj.expiresOn>process.env.Micro_Duration)) {
            return "";
        }else{
            return dataObj.data;
        }
    },
    // 清除缓存
    localRemove: function (name) {
        localStorage.removeItem(name)
    }
}
export default Storage



// WEBPACK FOOTER //
// ./src/utils/storage.js